import React from 'react';
import Helmet from 'react-helmet';
import 'typeface-open-sans';
import OpenSans400 from 'typeface-open-sans/files/open-sans-latin-400.woff';
import OpenSans600 from 'typeface-open-sans/files/open-sans-latin-600.woff';
import OpenSans700 from 'typeface-open-sans/files/open-sans-latin-700.woff';

const FontLoader = () => {
  return (
    <Helmet>
      <link rel="preload" href={OpenSans400} as="font" />
      <link rel="preload" href={OpenSans600} as="font" />
      <link rel="preload" href={OpenSans700} as="font" />
      <link rel="preload" href="https://content.edgeimpulse.com/618d2bcce8838407537454b9_Gotham-Book.ttf" as="font" />
      <link rel="preload" href="https://content.edgeimpulse.com/618d2bcc4a4197ce1ecf6810_Gotham-Bold.ttf" as="font" />
      <link rel="preload" href="https://content.edgeimpulse.com/Gotham-Light.ttf" as="font" />
      <link rel="preload" href="https://content.edgeimpulse.com/Gotham-Medium.ttf" as="font" />
    </Helmet>
  );
};

export default FontLoader;
